import React from "react";
import MyAccount from "../../screens/MyAccount";
import Profiles from "../../screens/Profiles";
import ProfilesDetailPage from "../../screens/ProfilesDetailPage";
import Application from "../../screens/Application";
import Cases from "../../screens/Cases";
import Notification from "../../screens/Notification";
import CaseDetail from "../../components/Cases/CaseDetails/CaseDetail";
import CaseDetailRegistrationNumber from "../../components/Cases/CaseDetails/RegistrationNumber";
import Network from "../../screens/Network";
import FormStatusComponent from "../../components/FormStatusComponent";

import Form790 from "../../components/Forms/Form790/Form790Wrapper";
import Form790V2 from "../../components/Forms/Form790V2/Form790V2Wrapper";
import Form9035 from "../../components/Forms/Form9035/Form9035Wrapper";
import Form9089 from "../../components/Forms/Form9089/Form9089Wrapper";
import Form9141 from "../../components/Forms/Form9141/Form9141Wrapper";
import Form9141C from "../../components/Forms/Form9141C/Form9141CWrapper";
import Form9142A from "../../components/Forms/Form9142A/Form9142AWrapper";
import Form9142AV2 from "../../components/Forms/Form9142AV2/Form9142AWrapper";
import Form9142B from "../../components/Forms/Form9142B/Form9142BWrapper";
import Form9142C from "../../components/Forms/Form9142C/Form9142CWrapper";

//There was old form CSS that was used that has been combined and imported at the top level here.
import "../../components/Form/components/combinedLegacyFormStyles.scss";

const routes = [
  {
    path: "/dashboard/application",
    exact: true,
    main: () => <Application />,
    title: "New Application | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard",
    exact: true,
    main: () => <Application />,
    title: "New Application | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/error",
    exact: true,
    main: () => <FormStatusComponent formStatusType={"error"} />,
  },
  {
    path: "/dashboard/success",
    exact: true,
    main: () => <FormStatusComponent formStatusType={"success"} />,
  },
  {
    path: "/",
    exact: true,
    main: () => <Application />,
    title: "New Application | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/myaccount",
    exact: true,
    main: () => <MyAccount />,
    title: "My Profile | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/myenterprise",
    exact: true,
    main: () => <Network type="Members" />,
    title: "My Enterprise | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/myenterprise/requested",
    exact: true,
    main: () => <Network type="Requested" />,
    title: "My Enterprise | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/profiles/employer/pocs/:profileName/:legalBusinessName/:fein/:id",
    exact: true,
    main: (props) => {
      let random = Math.floor(Math.random() * 100000);
      return (
        <ProfilesDetailPage
          key={random}
          type="employer-pocs"
          id={props.match.params.id}
          profileName={props.match.params.profileName}
          legalBusinessName={props.match.params.legalBusinessName}
          fein={props.match.params.fein}
        />
      );
    },
    title: "Employer Point of Contacts | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/profiles/employer",
    exact: true,
    main: () => {
      let random = Math.floor(Math.random() * 100000);
      return <ProfilesDetailPage type="employer" key={random} />;
    },
    title: "Employer Profiles | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/profiles/agent-attorney",
    exact: true,
    main: () => {
      let random = Math.floor(Math.random() * 100000);
      return <ProfilesDetailPage type="agent-attorney" key={random} />;
    },
    title: "Agent/Attorney Profiles | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/profiles/agent-attorney/individuals/:profileName/:legalBusinessName/:fein/:id",
    exact: true,
    main: (props) => {
      let random = Math.floor(Math.random() * 100000);
      return (
        <ProfilesDetailPage
          key={random}
          type="agent-attorney-individs"
          id={props.match.params.id}
          profileName={props.match.params.profileName}
          legalBusinessName={props.match.params.legalBusinessName}
          fein={props.match.params.fein}
        />
      );
    },
    title: "Agent/Attorney Individuals | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/profiles/foreign-labor",
    exact: true,
    main: () => {
      let random = Math.floor(Math.random() * 100000);
      return <ProfilesDetailPage type="foreign-labor" key={random} />;
    },
    title: "Foreign Labor Profiles | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/profiles/crop-commodity",
    exact: true,
    main: () => {
      let random = Math.floor(Math.random() * 100000);
      return <ProfilesDetailPage type="crop" key={random} />;
    },
    title: "Crop or Commodity Profiles | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/profiles/agriculture",
    exact: true,
    main: () => {
      let random = Math.floor(Math.random() * 100000);
      return <ProfilesDetailPage type="agriculture" key={random} />;
    },
    title: "Agricultural Business Profiles | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/profiles/worker-housing",
    exact: true,
    main: () => {
      let random = Math.floor(Math.random() * 100000);
      return <ProfilesDetailPage type="worker-housing" key={random} />;
    },
    title: "Worker Housing Profile | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/profiles/material-terms-of-employment",
    exact: true,
    main: () => {
      let random = Math.floor(Math.random() * 100000);
      return <ProfilesDetailPage type="material-terms" key={random} />;
    },
    title:
      "Material Terms of Employment Profile | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/profiles/foreign-worker",
    exact: true,
    main: () => {
      let random = Math.floor(Math.random() * 100000);
      return <ProfilesDetailPage type="foreign-worker" key={random} />;
    },
    title: "Foreign Worker Profile | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/profiles/foreign-worker-group",
    exact: true,
    main: () => {
      let random = Math.floor(Math.random() * 100000);
      return <ProfilesDetailPage type="foreign-worker-group" key={random} />;
    },
    title: "Foreign Worker Group | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/profiles",
    exact: true,
    main: () => <Profiles />,
    title: "Profiles | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/cases/submitted",
    exact: true,
    main: () => <Cases type="submitted" />,
    title: "Submitted Cases | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/cases/initiated",
    exact: true,
    main: () => {
      let random = Math.floor(Math.random() * 100000);
      return <Cases type="initiated" key={random} />;
    },
    title: "Initiated Cases | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/cases/historical",
    exact: true,
    main: () => <Cases type="historical" />,
    title: "Historical Cases | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/cases",
    exact: true,
    main: () => <Cases type="submitted" />,
    title: "Submitted Cases | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/notification-center",
    exact: true,
    main: () => <Notification />,
    title: "Notification | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/case/:form_id/:application_id",
    exact: true,
    main: (props) => {
      let random = Math.floor(Math.random() * 100000);
      return (
        <CaseDetail
          key={random}
          form_id={props.match.params.form_id}
          application_id={props.match.params.application_id}
          fein={props.match.params.fein}
        />
      );
    },
    title: "Case Detail",
  },
  {
    path: "/dashboard/registration/:formId/:registrationNumber",
    exact: true,
    main: (props) => {
      let random = Math.floor(Math.random() * 100000);
      return (
        <CaseDetailRegistrationNumber
          key={random}
          formId={props.match.params.formId}
          registrationNumber={props.match.params.registrationNumber}
        />
      );
    },
    title: "Case Detail",
  },
  {
    path: "/dashboard/application/790A/:id/V2",
    exact: true,
    main: (props) => <Form790V2 {...props} />,
    title: "790/790A Application | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/application/9035/:id",
    exact: true,
    main: (props) => <Form9035 {...props} />,
    title: "9035 Application | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/application/9089/:id",
    exact: true,
    main: (props) => <Form9089 {...props} />,
    title: "9089 Application | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/application/9141/:id",
    exact: true,
    main: (props) => <Form9141 {...props} />,
    title: "9141 Application | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/application/9141C/:id",
    exact: true,
    main: (props) => <Form9141C {...props} />,
    title: "9141C Application | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/application/9142A/:id/V2",
    exact: true,
    main: (props) => <Form9142AV2 {...props} />,
    title: "9142A Application | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/application/9142B/:id",
    exact: true,
    main: (props) => <Form9142B {...props} />,
    title: "9142B Application | Foreign Labor Application Gateway",
  },
  {
    path: "/dashboard/application/9142C/:id",
    exact: true,
    main: (props) => <Form9142C {...props} />,
    title: "9142C Application | Foreign Labor Application Gateway",
  },
];

export default routes;
